The webhook subscription that was the target of the replay.

This will be `null` if the subscription has since been deleted.
